
























































import CreateDialog from '@/components/CreateDialog.vue'
import mixins from 'vue-typed-mixins'
import { crudMixin } from '@/utils/mixins/crudMixin'
import { editMixin } from '@/utils/mixins/editMixin'
import { TopUpDeal } from '@/utils/interfaces/topup.interface'
import { VueForm } from '@/utils/interfaces'
import { createOrUpdateTopUpDeal } from '@/api/Topup/topup.api'
import DatePickerVue from '@/components/DatePicker.vue'

export default mixins(crudMixin, editMixin).extend({
  components: {
    appCreateDialog: CreateDialog,
    appDatePicker: DatePickerVue,
  },
  data() {
    return {
      rules: {
        required: (v: string) => !!v || this.$t('validation.field-required'),
      },
      loading: false,
      crud: {} as TopUpDeal,
      defaultCrud: {
        title: '',
        image: null as null | string,
        description: '',
        start_date: '',
        end_date: '',
        agency: this.$store.getters.agency.uuid,
      } as TopUpDeal,
    }
  },
  methods: {
    async onSuccess() {
      const form = this.$refs.form as VueForm
      if (!form.validate()) return
      try {
        this.loading = true
        const response = await createOrUpdateTopUpDeal(this.crud)
        this.$emit('new-item', response.data)
        this.$emit('input', false)
        this.resetCrud()
        form.resetValidation()
      } finally {
        this.loading = false
      }
    },
    allowedLower(v: string | undefined) {
      if (v) {
        if (this.crud.start_date) {
          return v >= this.crud.start_date
        } else return true
      } else return true
    },
    allowedBigger(v: string | undefined) {
      if (v) {
        if (this.crud.end_date) {
          return v <= this.crud.end_date
        } else return true
      } else return true
    },
  },
})
